












import Vue from 'vue';
import { Order } from '../models';
export default Vue.extend({
  computed: {
    ordersArray(): Order[] {
      return this.$store.state.ordersList;
    }
  }
});
